import { render, staticRenderFns } from "./handoverDoc.vue?vue&type=template&id=35b0da92&"
import script from "./handoverDoc.vue?vue&type=script&lang=js&"
export * from "./handoverDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports